import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import {
  toggleReportColumn,
  updatePlaylistReportParams,
} from '@disco/state-management/actions/ReportActions'
import Checkbox from 'components/ui/checkbox'
type OwnProps = {
  formKey?: string
  columnKey?: string
}

function mapStateToProps(
  state: State,
  ownProps: OwnProps,
): {
  value: boolean
} {
  let value

  if (ownProps.formKey) {
    value = !!state.reports.playlistReport.form[ownProps.formKey]
  } else if (ownProps.columnKey) {
    value = state.reports.playlistReport.visibleColumns.includes(
      ownProps.columnKey,
    )
  } else {
    throw new Error(
      'ReportCheckbox requires formKey/columnKey ' + JSON.stringify(ownProps),
    )
  }

  return {
    value,
  }
}

function mapDispatchToProps(dispatch: any, ownProps: OwnProps): any {
  return {
    onChange(_, value) {
      if (ownProps.formKey) {
        dispatch(
          updatePlaylistReportParams({
            [ownProps.formKey]: value,
          }),
        )
      } else if (ownProps.columnKey) {
        dispatch(toggleReportColumn(ownProps.columnKey, value))
      }
    },
  }
}

class ReportCheckbox extends React.Component<{
  children?: React.ReactNode
  className?: string
  value: boolean
  onChange: (...args: Array<any>) => any
  disabled?: boolean
}> {
  render() {
    const { children, value, onChange, disabled } = this.props
    return (
      <Checkbox
        className={this.props.className}
        checked={value}
        onChange={onChange}
        disabled={disabled}
      >
        {children}
      </Checkbox>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportCheckbox) as any
